
import { defineComponent } from 'vue'
import JrInputView from '@/components/jr-parts/JrInputView.vue'

export default defineComponent({
  name: 'JrCheckbox',
  emits: ['update:modelValue'],
  components: { JrInputView },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    return {
      update: (event: boolean) => {
        context.emit('update:modelValue', event)
      },
    }
  },
})
